var _path, _path2, _g, _g2, _g3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _g4, _path3, _path4, _path5, _circle, _path6, _path7, _path8, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800.366,
    height: 341.574,
    viewBox: "0 0 800.366 341.574",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-569.67 -223.146)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M311.446,467.2H30.128A30.162,30.162,0,0,1,0,437.074V30.128A30.162,30.162,0,0,1,30.128,0H311.446a30.162,30.162,0,0,1,30.128,30.128V437.074A30.163,30.163,0,0,1,311.446,467.2Z",
    transform: "translate(1197.801 223.146) rotate(90)",
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M289.009,428.611H8.226A8.235,8.235,0,0,1,0,420.385V8.226A8.235,8.235,0,0,1,8.226,0H289.009a8.235,8.235,0,0,1,8.226,8.226V420.385A8.235,8.235,0,0,1,289.009,428.611Z",
    transform: "translate(1176.285 245.316) rotate(90)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(812.213 439.349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512.7,410.083a31.631,31.631,0,0,0-51.062-4.717l-2.036-1.779a34.329,34.329,0,0,1,55.424,5.119Z",
    transform: "translate(-451.125 -391.831)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.036,463.126l-2.244-1.508a31.647,31.647,0,0,0,.97-33.709l2.326-1.377A34.351,34.351,0,0,1,569.036,463.126Z",
    transform: "translate(-506.192 -409.657)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.929,461.484a34.327,34.327,0,0,1-.282-45.479l2.036,1.779a31.624,31.624,0,0,0,.258,41.9Z",
    transform: "translate(-442.175 -404.25)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.755,515.388a34.385,34.385,0,0,1-25.579-11.437l2.014-1.8a31.631,31.631,0,0,0,49.833-3.471l2.244,1.508a34.31,34.31,0,0,1-28.511,15.2Z",
    transform: "translate(-451.422 -446.718)",
    fill: "#75c4c0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(927.647 439.349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512.7,410.083a31.631,31.631,0,0,0-51.062-4.717l-2.036-1.779a34.329,34.329,0,0,1,55.424,5.119Z",
    transform: "translate(-451.125 -391.831)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.036,463.126l-2.244-1.508a31.647,31.647,0,0,0,.97-33.709l2.326-1.377A34.351,34.351,0,0,1,569.036,463.126Z",
    transform: "translate(-506.192 -409.657)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.929,461.484a34.327,34.327,0,0,1-.282-45.479l2.036,1.779a31.624,31.624,0,0,0,.258,41.9Z",
    transform: "translate(-442.175 -404.25)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.755,515.388a34.385,34.385,0,0,1-25.579-11.437l2.014-1.8a31.631,31.631,0,0,0,49.833-3.471l2.244,1.508a34.31,34.31,0,0,1-28.511,15.2Z",
    transform: "translate(-451.422 -446.718)",
    fill: "#e6e6e6"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1043.081 439.349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512.7,410.083a31.631,31.631,0,0,0-51.062-4.717l-2.036-1.779a34.329,34.329,0,0,1,55.424,5.119Z",
    transform: "translate(-451.125 -391.831)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.036,463.126l-2.244-1.508a31.647,31.647,0,0,0,.97-33.709l2.326-1.377A34.351,34.351,0,0,1,569.036,463.126Z",
    transform: "translate(-506.192 -409.657)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.929,461.484a34.327,34.327,0,0,1-.282-45.479l2.036,1.779a31.624,31.624,0,0,0,.258,41.9Z",
    transform: "translate(-442.175 -404.25)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.755,515.388a34.385,34.385,0,0,1-25.579-11.437l2.014-1.8a31.631,31.631,0,0,0,49.833-3.471l2.244,1.508a34.31,34.31,0,0,1-28.511,15.2Z",
    transform: "translate(-451.422 -446.718)",
    fill: "#75c4c0"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11.832,
    height: 6.652,
    rx: 2,
    transform: "translate(829.872 465.632)",
    fill: "#75c4c0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 33.347,
    height: 3.118,
    rx: 1.559,
    transform: "translate(829.872 478.619)",
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 11.832,
    height: 6.652,
    rx: 2,
    transform: "translate(947.526 465.632)",
    fill: "#75c4c0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 33.347,
    height: 3.118,
    rx: 1.559,
    transform: "translate(947.526 478.619)",
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 11.832,
    height: 6.652,
    rx: 2,
    transform: "translate(1060.74 465.632)",
    fill: "#75c4c0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 33.347,
    height: 3.118,
    rx: 1.559,
    transform: "translate(1060.74 478.619)",
    fill: "#e6e6e6"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(865.992 286.022)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.619,
    height: 7.13,
    rx: 3.565,
    transform: "translate(37.298)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.421,
    height: 7.13,
    rx: 3.565,
    transform: "translate(159.064)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.421,
    height: 7.13,
    rx: 3.565,
    transform: "translate(179.908)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.756,
    height: 7.13,
    rx: 3.565,
    transform: "translate(77.338)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.619,
    height: 7.13,
    rx: 3.565,
    transform: "translate(0.001 46.074)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.421,
    height: 7.13,
    rx: 3.565,
    transform: "translate(121.767 46.074)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.421,
    height: 7.13,
    rx: 3.565,
    transform: "translate(142.61 46.074)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.756,
    height: 7.13,
    rx: 3.565,
    transform: "translate(40.041 46.074)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.619,
    height: 7.13,
    rx: 3.565,
    transform: "translate(122.316 15.906)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.619,
    height: 7.13,
    rx: 3.565,
    transform: "translate(0.001 15.906)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.421,
    height: 7.13,
    rx: 3.565,
    transform: "translate(0.001)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.421,
    height: 7.13,
    rx: 3.565,
    transform: "translate(0 31.264)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.756,
    height: 7.13,
    rx: 3.565,
    transform: "translate(41.686 15.906)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.619,
    height: 7.13,
    rx: 3.565,
    transform: "translate(60.884 31.264)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.619,
    height: 7.13,
    rx: 3.565,
    transform: "translate(20.843 31.264)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.421,
    height: 7.13,
    rx: 3.565,
    transform: "translate(18.675)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.421,
    height: 7.13,
    rx: 3.565,
    transform: "translate(181.553 31.264)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.756,
    height: 7.13,
    rx: 3.565,
    transform: "translate(100.375 31.264)",
    fill: "#75c4c0"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M286.549,192.205l-26.939,26.6,26.939,26.6,6.061-6.061-20.37-20.373,20.541-20.541Z",
    transform: "translate(552.602 93.817)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M326.4,192.205l26.938,26.6L326.4,245.41l-6.061-6.061,20.372-20.372-20.542-20.541Z",
    transform: "translate(758.411 93.817)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M472.167,337.638h297.08V320.916c-.091-3.562-4.549-6.962-12.366-9.431l-.081-.026a141.828,141.828,0,0,0-41.386-5.809c-9.692.2-17.989,1.732-24.662,4.559-20.769,8.8-48.052,5.832-62.466,3.277a206.044,206.044,0,0,0-38.562-3.141c-18.046.232-43.446,2.415-61.97,11.5-7.075,3.467-22.461,8.173-55.588,10.939Z",
    transform: "translate(341.273 72.301)",
    fill: "#75c4c0",
    style: {
      isolation: "isolate"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M412.912,50.837l50.779-35.4h34.23v.52H463.926l-50.6,35.276Z",
    transform: "translate(769.444 367.362)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.556,
    cy: 10.556,
    r: 10.556,
    transform: "translate(1267.364 372.902)",
    fill: "#75c4c0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M938.155,174.823H841.773a3.145,3.145,0,0,1,0-6.29h96.382a3.145,3.145,0,0,1,0,6.29Z",
    transform: "translate(428.736 243.771)",
    fill: "#75c4c0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M938.155,194.2H841.773a3.145,3.145,0,1,1,0-6.29h96.382a3.145,3.145,0,0,1,0,6.29Z",
    transform: "translate(428.736 236.818)",
    fill: "#75c4c0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M883.553,213.572h-41.78a3.145,3.145,0,0,1,0-6.29h41.78a3.145,3.145,0,0,1,0,6.29Z",
    transform: "translate(428.736 229.863)",
    fill: "#75c4c0"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(569.67 276.088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M717.889,331.6c-2.426-10.192-2.022-20.23,2.133-30.064a2.3,2.3,0,0,1,2.458-2.133l22.705,1.611a2.3,2.3,0,0,1,2.132,2.458l-2.134,30.065a2.3,2.3,0,0,1-2.458,2.133l-22.7-1.612a2.3,2.3,0,0,1-2.136-2.458Z",
    transform: "translate(-716.395 -193.697)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.546,324.795c-1.942-5.022-.7-11.929,1.371-19.328a2.157,2.157,0,0,1,2.3-2l19.513,1.384a2.157,2.157,0,0,1,2,2.3l-1.9,26.753a2.158,2.158,0,0,1-2.3,2l-12.088-.858a9.609,9.609,0,0,1-8.9-10.254Z",
    transform: "translate(-719.667 -195.849)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.694,335.4l-1.788-.307a6.008,6.008,0,0,0,.468-2.042c.282-3.763.311-7.561.461-11.332a.715.715,0,0,0-1.205-.5l-4.491,3.72c-.7.58.3,1.575,1,1l3.223-2.67-.3,7.411a10.729,10.729,0,0,1-.388,3.741,1.8,1.8,0,0,1-.258.418l-1.979-.34c-.474-.081-1.077.314-.869.869a2.166,2.166,0,0,0,2.941,1.121,2.385,2.385,0,0,0,.3-.157l2.516.432C746.208,336.91,746.59,335.549,745.694,335.4Z",
    transform: "translate(-728.305 -205.139)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.805,544.726c-2.286-9.6-1.9-19.053,2.009-28.315a2.169,2.169,0,0,1,2.315-2.008l21.385,1.518a2.17,2.17,0,0,1,2.008,2.315l-2.009,28.315a2.17,2.17,0,0,1-2.315,2.008l-21.385-1.518A2.17,2.17,0,0,1,997.805,544.726Z",
    transform: "translate(-975.262 -333.824)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.489,538.554c-1.829-4.73-.659-11.235,1.292-18.2a2.032,2.032,0,0,1,2.168-1.881l18.378,1.3a2.031,2.031,0,0,1,1.881,2.168l-1.788,25.2a2.032,2.032,0,0,1-2.168,1.881l-11.384-.808a9.05,9.05,0,0,1-8.379-9.657Z",
    transform: "translate(-978.701 -336.087)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.4,543.7a3.744,3.744,0,0,0,.69-.418,3.817,3.817,0,0,0,1.248-3.969c-.862-3.168-4.651-3.187-7.268-2.806-.844.123-.485,1.406.354,1.283,1.763-.257,4.531-.465,5.476,1.461a2.53,2.53,0,0,1-.4,2.787,2.461,2.461,0,0,1-1.5.712,3.957,3.957,0,0,0-1.742-.325c-.616.029-.962.926-.336,1.239a4,4,0,0,0,1.776.42,2.886,2.886,0,0,1,1.628,2.748,2.981,2.981,0,0,1-3.394,2.5h-.016c-.836-.168-1.194,1.114-.354,1.283a4.324,4.324,0,0,0,5.049-3.448q.017-.092.03-.183a4.04,4.04,0,0,0-1.239-3.284Z",
    transform: "translate(-987.612 -346.033)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.089,208.906c-2.751-11.555-2.294-22.934,2.418-34.084a2.611,2.611,0,0,1,2.787-2.417l25.74,1.826a2.611,2.611,0,0,1,2.417,2.787l-2.42,34.082a2.611,2.611,0,0,1-2.787,2.417l-25.738-1.825A2.611,2.611,0,0,1,944.089,208.906Z",
    transform: "translate(-915.346 -161.375)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.676,200.647c-2.2-5.694-.794-13.524,1.554-21.913a2.445,2.445,0,0,1,2.61-2.264l22.125,1.569a2.446,2.446,0,0,1,2.264,2.61l-2.153,30.33a2.446,2.446,0,0,1-2.61,2.264l-13.7-.972a10.894,10.894,0,0,1-10.086-11.625Z",
    transform: "translate(-918.229 -163.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.7,193.022a3.851,3.851,0,1,0-.049,7.329.8.8,0,0,0-.426-1.544c-1.8.525-3.717-1.418-2.684-3.154a2.368,2.368,0,0,1,2.416-1.184,2.679,2.679,0,0,1,1.785,1.62c.883,1.989-.166,4.008-1.554,5.454-.793.824-1.723,1.465-2.578,2.22a3.727,3.727,0,0,0-1.466,2.645,3.2,3.2,0,0,0,1.821,2.766,6.974,6.974,0,0,0,4.37.245c1.014-.164.584-1.706-.425-1.544-1.271.2-3.172.514-3.977-.814-.69-1.134.731-2.13,1.5-2.733,1.945-1.516,3.911-3.478,4.2-6.053A4.956,4.956,0,0,0,971.7,193.022Z",
    transform: "translate(-926.643 -170.91)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.354 108.408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M524.262,403.361c8.979-2.79,18.591.227,27.619-2.348a18.722,18.722,0,0,0,5.8-2.725,36.057,36.057,0,0,0,4.223-3.758c2.716-2.686,5.665-5.507,9.745-5.476,5.373.041,9.5,4.032,13.08,7.556.506.5,1.286-.281.78-.78-3.291-3.238-6.846-6.654-11.531-7.622a10.641,10.641,0,0,0-6.29.522,16.419,16.419,0,0,0-4.674,3.2c-1.442,1.323-2.773,2.763-4.235,4.065a17.631,17.631,0,0,1-5.194,3.279c-4.139,1.648-8.678,1.85-13.08,1.8-5.526-.06-11.183-.437-16.537,1.227-.676.21-.387,1.274.3,1.063Z",
    transform: "translate(-523.585 -387.956)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.549,389.889l2.76,4.865,1.332,2.355c.237.418.481.834.713,1.258.142.259.452.727.156.972a1.438,1.438,0,0,1-.839.131c-.486,0-.973-.01-1.46-.015l-2.738-.027-5.657-.057a.551.551,0,0,0,0,1.1c3.284.033,6.57.1,9.854.1a2.356,2.356,0,0,0,1.612-.444,1.533,1.533,0,0,0,.3-1.767,16.782,16.782,0,0,0-1.114-2.045l-1.2-2.119-2.76-4.865a.552.552,0,0,0-.952.556Z",
    transform: "translate(-621.431 -388.666)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(78.497 38.289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M768.876,279.724c4.324,5.862,11.708,8.39,16.162,14.141a14.5,14.5,0,0,1,2.368,4.366,27.924,27.924,0,0,1,.912,4.284c.462,2.923,1.009,6.037,3.57,7.89,3.373,2.442,7.779,1.842,11.632,1.286a.427.427,0,1,1,.129.844c-3.54.511-7.326,1.012-10.695-.534a8.244,8.244,0,0,1-3.686-3.213,12.728,12.728,0,0,1-1.451-4.144c-.3-1.488-.463-3-.778-4.481a13.656,13.656,0,0,0-1.738-4.431,26.49,26.49,0,0,0-7.34-7.126c-3.478-2.5-7.178-4.86-9.759-8.355-.326-.444.343-.973.671-.529Z",
    transform: "translate(-768.115 -279.555)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.273,274.009l5.106-2.285,2.471-1.105c.439-.2.881-.387,1.318-.592.268-.125.795-.317.7-.691-.064-.255-.4-.459-.6-.6-.391-.289-.79-.568-1.184-.853l-2.22-1.6-4.591-3.3a.551.551,0,1,1,.653-.888c2.664,1.919,5.354,3.809,8,5.757a2.356,2.356,0,0,1,1.036,1.31,1.533,1.533,0,0,1-.814,1.6,16.79,16.79,0,0,1-2.109.987l-2.22,1-5.106,2.285a.552.552,0,0,1-.437-1.012Z",
    transform: "translate(-851.818 -235.115)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.051 154.018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M821.974,524.236c4.861-6.59,13.162-9.431,18.168-15.9a16.3,16.3,0,0,0,2.664-4.905,31.4,31.4,0,0,0,1.025-4.816c.518-3.286,1.134-6.786,4.014-8.869,3.792-2.743,8.745-2.072,13.076-1.445a.48.48,0,1,0,.148-.949c-3.979-.575-8.237-1.137-12.022.6a9.267,9.267,0,0,0-4.144,3.612,14.3,14.3,0,0,0-1.628,4.654c-.33,1.672-.518,3.369-.875,5.037a15.359,15.359,0,0,1-1.954,4.981c-2.054,3.291-5.137,5.772-8.251,8.01-3.908,2.812-8.072,5.463-10.971,9.392-.365.5.386,1.094.754.592Z",
    transform: "translate(-821.127 -480.33)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.273,587.438l5.106,2.285,2.471,1.105c.439.2.881.387,1.318.592.268.125.795.317.7.691-.064.255-.4.459-.6.6-.391.289-.79.568-1.184.853l-2.22,1.6-4.591,3.3a.551.551,0,1,0,.653.888c2.664-1.919,5.354-3.809,8-5.757a2.356,2.356,0,0,0,1.036-1.31,1.533,1.533,0,0,0-.814-1.6,16.778,16.778,0,0,0-2.109-.987l-2.22-1-5.106-2.285a.552.552,0,0,0-.437,1.012Z",
    transform: "translate(-900.372 -586.393)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.27 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.254,
    cy: 11.254,
    r: 11.254,
    transform: "translate(4.295 0) rotate(11)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.778,8.559a1.167,1.167,0,0,1-.7-.233l-.01-.01L.418,6.289a1.175,1.175,0,0,1,1.43-1.862L3.562,5.741,7.61.46A1.175,1.175,0,0,1,9.257.242h0L9.232.277,9.258.242A1.177,1.177,0,0,1,9.475,1.89L4.714,8.1a1.176,1.176,0,0,1-.935.458Z",
    transform: "translate(9.206 8.073) rotate(11)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.431 169.183)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.065,
    cy: 12.065,
    r: 12.065,
    transform: "translate(4.604 0) rotate(11)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.094,9.176a1.251,1.251,0,0,1-.753-.25l-.013-.01L.493,6.748a1.259,1.259,0,1,1,1.533-2L3.862,6.156,8.2.494A1.258,1.258,0,0,1,9.969.261h0L9.942.3,9.969.259A1.258,1.258,0,0,1,10.2,2.025L5.1,8.685a1.258,1.258,0,0,1-1,.491Z",
    transform: "translate(9.826 8.646) rotate(11)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.899 93.216)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.81,
    cy: 12.81,
    r: 12.81,
    transform: "translate(4.889 0) rotate(11)",
    fill: "#75c4c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.348,9.741a1.332,1.332,0,0,1-.8-.266l-.014-.011L.524,7.162A1.338,1.338,0,0,1,2.152,5.038L4.1,6.534,8.71.522A1.337,1.337,0,0,1,10.582.274h0l-.029.04.03-.04a1.339,1.339,0,0,1,.247,1.875L5.414,9.218A1.338,1.338,0,0,1,4.35,9.74Z",
    transform: "translate(10.431 9.182) rotate(11)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.8b904de15d22d7508dc939711df92182.svg";
export { ForwardRef as ReactComponent };